import b1 from "../../../src/assets/sounds/pronunciation/Ba.mp3"
import b2 from "../../../src/assets/sounds/pronunciation/Bà.mp3"
import b3 from "../../../src/assets/sounds/pronunciation/Bá.mp3"
import b4 from "../../../src/assets/sounds/pronunciation/Bã.mp3"
import b5 from "../../../src/assets/sounds/pronunciation/Bả.mp3"
import b6 from "../../../src/assets/sounds/pronunciation/Bạ.mp3"

import c1 from "../../../src/assets/sounds/pronunciation/Ca.mp3"
import c2 from "../../../src/assets/sounds/pronunciation/Cà.mp3"
import c3 from "../../../src/assets/sounds/pronunciation/Cá.mp3"
import c4 from "../../../src/assets/sounds/pronunciation/Cã.mp3"
import c5 from "../../../src/assets/sounds/pronunciation/Cả.mp3"
import c6 from "../../../src/assets/sounds/pronunciation/Cạ.mp3"

import d1 from "../../../src/assets/sounds/pronunciation/Da.mp3"
import d2 from "../../../src/assets/sounds/pronunciation/Dà.mp3"
import d3 from "../../../src/assets/sounds/pronunciation/Dá.mp3"
import d4 from "../../../src/assets/sounds/pronunciation/Dã.mp3"
import d5 from "../../../src/assets/sounds/pronunciation/Dả.mp3"
import d6 from "../../../src/assets/sounds/pronunciation/Dạ.mp3"

import h1 from "../../../src/assets/sounds/pronunciation/Ha.mp3"
import h2 from "../../../src/assets/sounds/pronunciation/Hà.mp3"
import h3 from "../../../src/assets/sounds/pronunciation/Há.mp3"
import h4 from "../../../src/assets/sounds/pronunciation/Hã.mp3"
import h5 from "../../../src/assets/sounds/pronunciation/Hả.mp3"
import h6 from "../../../src/assets/sounds/pronunciation/Hạ.mp3"

import l1 from "../../../src/assets/sounds/pronunciation/La.mp3"
import l2 from "../../../src/assets/sounds/pronunciation/Là.mp3"
import l3 from "../../../src/assets/sounds/pronunciation/Lá.mp3"
import l4 from "../../../src/assets/sounds/pronunciation/Lã.mp3"
import l5 from "../../../src/assets/sounds/pronunciation/Lả.mp3"
import l6 from "../../../src/assets/sounds/pronunciation/Lạ.mp3"
export const pronunciation ={
    'Ba': b1 , 
    'Bà': b2, 
    'Bá': b3, 
    'Bã': b4, 
    'Bả': b5, 
    'Bạ': b6, 
    'Ca': c1, 
    'Cà': c2, 
    'Cá': c3, 
    'Cã': c4, 
    'Cả': c5, 
    'Cạ': c6, 
    'Da': d1, 
    'Dà': d2, 
    'Dá': d3, 
    'Dã': d4, 
    'Dả': d5, 
    'Dạ': d6, 
    'Ha': h1, 
    'Hà': h2, 
    'Há': h3, 
    'Hã': h4, 
    'Hả': h5, 
    'Hạ': h6, 
    'La': l1, 
    'Là': l2, 
    'Lá': l3, 
    'Lã': l4, 
    'Lả': l5, 
    'Lạ': l6, 
}